export default "__VITE_PUBLIC_ASSET__3cda0bc1__"